/**
  Utility functions such as date format, time since, etc
*/

export default class ZUtil {

  // format masa 2025-02-25 11:04:22 -> 11:04 PM
  formatDateToTime(datetime) {
    if (typeof datetime !== 'string' || datetime.trim() === '') {
        return '-'; 
    }
    if (typeof datetime !== "string") {
        return '-';
    }
    let [datePart, timePart] = datetime.split(" ");
    let [hours, minutes] = timePart.split(":").map(Number);
    let period = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;

    return `${hours}:${minutes.toString().padStart(2, '0')} ${period}`;
  }

  //format masa 2025-01-16T02:01:18.000000Z -> 2:01 AM
  formatTime(date) {
    if (!(date instanceof Date) || isNaN(date.getTime())) {
        date = new Date(date);
    }

    if (date instanceof Date && !isNaN(date.getTime())) {
        let hours = date.getUTCHours();
        let minutes = date.getUTCMinutes(); 
        let ampm = hours >= 12 ? 'PM' : 'AM'; // Tentukan AM/PM

        hours = hours % 12; 
        hours = hours ? hours : 12; 
        minutes = minutes < 10 ? '0' + minutes : minutes;

        return `${hours}:${minutes} ${ampm}`;
    } else {
        return '-'; 
    }
  }

  //format masa 21:00:00 -> 9:00 PM
  formatMasa(time) {
    if (typeof time !== 'string' || time.trim() === '') {
        return '-'; 
    }

    let [hours, minutes, seconds] = time.split(':').map(Number); 

    if (isNaN(hours) || isNaN(minutes) || isNaN(seconds)) {
        console.error("Format waktu tidak valid");
        return '-'; 
    }

    const ampm = hours >= 12 ? 'PM' : 'AM';
    let hour12 = hours % 12;
    hour12 = hour12 ? hour12 : 12;
    
    // Format menit menjadi 2 digit jika kurang dari 10
    minutes = minutes < 10 ? '0' + minutes : minutes;
    return `${hour12}:${minutes} ${ampm}`;
  }

  //format ke decimal 
  formatDecimal(x) {
    if(x === null || x === ''){
      return '0.00';
    }
    if (!isNaN(x)) {
        return parseFloat(x)
            .toFixed(2)
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    return x;
  }

  currency(x) {
    if(x)
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  timeSince (date) {
  if (typeof date !== 'object') {
    date = new Date(date);
  }

  var seconds = Math.floor((new Date() - date) / 1000);
  var intervalType;

  var interval = Math.floor(seconds / 31536000);
  if (interval >= 1) {
    intervalType = 'tahun';
  } else {
    interval = Math.floor(seconds / 2592000);
    if (interval >= 1) {
      intervalType = 'bulan';
    } else {
      interval = Math.floor(seconds / 86400);
      if (interval >= 1) {
        intervalType = 'hari';
      } else {
        interval = Math.floor(seconds / 3600);
        if (interval >= 1) {
          intervalType = "jam";
        } else {
          interval = Math.floor(seconds / 60);
          if (interval >= 1) {
            intervalType = "minit";
          } else {
            interval = seconds;
            intervalType = "saat";
          }
        }
      }
    }
  }

  if (interval > 1 || interval === 0) {
    intervalType += '';
  }

  return interval + ' ' + intervalType;
};

  dateformat(date) {
    if (typeof date !== 'object') {
      date = new Date(date);
    }
    if(date && date != "Invalid Date") {
      var dd = String(date.getUTCDate()).padStart(2, '0');
      var mm = String(date.getUTCMonth() + 1).padStart(2, '0'); //January is 0!
      var yyyy = date.getUTCFullYear();

      return dd + '/' + mm + '/' + yyyy;
    }
    else {
      return '-'
    }
  };

  umur(date) {
    if (typeof date !== 'object') {
      date = new Date(date);
    }
    if(date) {
      var current = new Date();
      var c_dd = String(current.getUTCDate()).padStart(2, '0');
      var c_mm = String(current.getUTCMonth() + 1).padStart(2, '0'); 
      var c_yyyy = current.getUTCFullYear();
      var dd = String(date.getUTCDate()).padStart(2, '0');
      var mm = String(date.getUTCMonth() + 1).padStart(2, '0'); 
      var yyyy = date.getUTCFullYear();
      
      
      if(mm <= c_mm && dd <= c_dd){
        return  (c_yyyy - yyyy )  + ' Tahun';
      }else{
        return  (c_yyyy - yyyy  - 1)  + ' Tahun';
      }
    }
    else {
      return '-'
    }
  };

  bulan(date) {
    if (typeof date !== 'object') {
      date = new Date(date);
    }
    if(date) {
      var current = new Date();
      var c_dd = String(current.getUTCDate()).padStart(2, '0');
      var c_mm = String(current.getUTCMonth() + 1).padStart(2, '0'); 
      var c_yyyy = current.getUTCFullYear();
      var dd = String(date.getUTCDate()).padStart(2, '0');
      var mm = String(date.getUTCMonth() + 1).padStart(2, '0'); 
      var yyyy = date.getUTCFullYear();
      
      
      if(mm <= c_mm && dd <= c_dd){
        return  (c_mm - mm + 12)  + ' Bulan' ;
      }else{
        return  (c_mm - mm + 12)  + ' Bulan' ;
      }
    }
    else {
      return '-'
    }
  };

  umurbulan(date) {
    if (typeof date !== 'object') {
      date = new Date(date);
    }
    if(date) {
      var current = new Date();
      var c_dd = String(current.getUTCDate()).padStart(2, '0');
      var c_mm = String(current.getUTCMonth() + 1).padStart(2, '0'); 
      var c_yyyy = current.getUTCFullYear();
      var dd = String(date.getUTCDate()).padStart(2, '0');
      var mm = String(date.getUTCMonth() + 1).padStart(2, '0'); 
      var yyyy = date.getUTCFullYear();
      
      if(mm <= c_mm && dd <= c_dd)
      {
        return  (c_yyyy - yyyy )  + ' Tahun' + '  ' + (c_mm - mm )  + ' Bulan' ;
      }
      else if(mm <= c_mm )
      {
        return  (c_yyyy - yyyy )  + ' Tahun' + '  ' + (c_mm - mm )  + ' Bulan' ;
      }
      else if (yyyy != c_yyyy)
      {
        return  (c_yyyy - yyyy - 1)  + ' Tahun' + '  ' + (c_mm - mm + 12)  + ' Bulan' ;
      }
    }
    else {
      return '-'
    }
  };

  umurHari(date1, date2){
    if(date1 && date2){
      const firstDate = new Date(date1) 
      const secondDate = new Date(date2) 
      

      const millisecondsDiff = secondDate.getTime() - firstDate.getTime()

      return Math.round(millisecondsDiff / (24 * 60 * 60 * 1000))
    }else{
      return 0
    }
  };


  umurLengkap(date) {
  if (typeof date !== 'object') {
    date = new Date(date);
  }
  if (date) {
    const current = new Date();

    let years = current.getFullYear() - date.getFullYear();
    let months = current.getMonth() - date.getMonth();
    let days = current.getDate() - date.getDate();

    if (days < 0) {
      months--;
      const prevMonth = new Date(current.getFullYear(), current.getMonth(), 0);
      days += prevMonth.getDate();
    }

    if (months < 0) {
      years--;
      months += 12;
    }

    return `${years} Tahun ${months} Bulan ${days} Hari`;
  } else {
    return '-';
  }
};

  
   umurBln(date) {
     var d1 = new Date(date)
      var d2 = new Date()

      var months;
      months = (d2.getFullYear() - d1.getFullYear()) * 12;
      months -= d1.getMonth();
      months += d2.getMonth();
      return months <= 0 ? 0 : months;
    };

  dateformformat(date) {
    if (typeof date !== 'object') {
      date = new Date(date);
    }

    // return date.toJSON().slice(0, 10).replace(/-/g, '-');

    var dd = String(date.getUTCDate()).padStart(2, '0');
    var mm = String(date.getUTCMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = date.getUTCFullYear();

    return yyyy + '-' + mm + '-' + dd;

    let m = date.getMonth()
    m = m < 10 ? '0' + m : m;
    let d = date.getDay()
    d = d < 10 ? '0' + d : d;

    return date.getFullYear() + '-' + m + '-' + d ;
  };

  dateformatBulanTahun(date) {
    if (typeof date !== 'object') {
      date = new Date(date);
    }

    if(date) {
      var dd = String(date.getUTCDate()).padStart(2, '0');
      var mm = String(date.getUTCMonth() + 1).padStart(2, '0'); //January is 0!
      var yyyy = date.getUTCFullYear();

      return mm + '/' + yyyy;
    }
    else {
      return '-'
    }
  };


   can(permissionName) {
    return this.app.$page.props.auth.user.permissions.indexOf(permissionName) !== -1;
  };

  role(roleName) {
    return this.app.$page.props.auth.user.roles.indexOf(roleName) !== -1;
  };

  anyRole(roles){
    var check = false;
    for (var i in roles) 
     {
       if(this.role(roles[i])){
         check = true
       }
     }

     return check
  }

  anyCan(cans){
    var check = false;
    for (var i in cans) 
     {
       if(this.can(cans[i])){
         check = true
       }
     }

     return check
  }

  capital(str){
    return (str + '').replace(/^([a-z])|\s+([a-z])/g, function ($1) {
        return $1.toUpperCase();
    });
  }

  pasti(msg = 'Adakah anda pasti?', title = 'Memohon Kepastian') {

    const swalWithBootstrapButtons = this.app.$swal.mixin({
      customClass: {
        confirmButton: 'btn btn-success ml-2',
        cancelButton: 'btn btn-danger ml-2'
      },
      buttonsStyling: false
    })

    return new Promise((resolve, reject) => {
        swalWithBootstrapButtons.fire({
        title: title,
        text: msg,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ya',
        cancelButtonText: 'Batal',
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          resolve(result.value)
          // swalWithBootstrapButtons.fire(
          //   'Deleted!',
          //   'Your file has been deleted.',
          //   'success'
          // )
        } else if (
          /* Read more about handling dismissals below */
          result.dismiss === 'cancel'
        ) {
          resolve(false)
          // swalWithBootstrapButtons.fire(
          //   'Cancelled',
          //   'Your imaginary file is safe :)',
          //   'error'
          // )
        }
      })
      .catch(err => {
        reject(err)
      })
    }); // promise
  }


  timeConvert (date) {
      return (new Date(date)).toLocaleTimeString('en-MY', { hour12: false })
  }

  zeroPad (num, places) { return String(num).padStart(places, '0')}

  globalRoute(named, param) {
    if (route().check(named)) {
      return route(named, param)
    }

    return this.app.globalRoute().check(named) ? this.app.globalRoute(named, param) + '?logged=' + this.app.$page.auth.user.token : '/'
  }

  notify(msg, success = true, onConfirm = null) {
    if(success)
      this.app.$page.props.flash.notify = msg
    else
      this.app.$page.props.flash.notifyerror = msg

    this.notifSweet(msg, onConfirm, success ? 'success' : 'error');
  }

    message(msg, success = true) {
    if(success) {
      this.app.$page.props.flash.success = ''
      this.app.$page.props.flash.success = msg
    }
    else {
      this.app.$page.props.flash.error = ''
      this.app.$page.props.flash.error = msg
    }
  }

  notifSweet(text, onConfirm, icon, title="") {
    // alert(text);
    this.app.$swal({
      title:title,
      text:text,
      icon:icon,
      confirmButtonText: 'OK'
    }).then(() => {
      if (onConfirm) onConfirm();  // <-- jalankan callback jika ada
    });
  }

  notifSweet2(text, text2, icon, title="") {
    this.app.$swal({
      title:text,
      text:text2,
      icon:icon
    });
  }


}
